__turbopack_context__.v({
  "button": "RequestDemoPopup-module-scss-module__scgbUG__button",
  "closeIcon": "RequestDemoPopup-module-scss-module__scgbUG__closeIcon",
  "container": "RequestDemoPopup-module-scss-module__scgbUG__container",
  "demoContainer": "RequestDemoPopup-module-scss-module__scgbUG__demoContainer",
  "description": "RequestDemoPopup-module-scss-module__scgbUG__description",
  "form": "RequestDemoPopup-module-scss-module__scgbUG__form",
  "image": "RequestDemoPopup-module-scss-module__scgbUG__image",
  "title": "RequestDemoPopup-module-scss-module__scgbUG__title",
});
